var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternship(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "employee-man",
    d: "M24,17.5V18H12v-.5a3.494,3.494,0,0,1,3-3.449A2.046,2.046,0,0,1,17,12h2a2.046,2.046,0,0,1,2,2.051A3.494,3.494,0,0,1,24,17.5Zm-14,0a5.433,5.433,0,0,1,1.093-3.244A8.966,8.966,0,0,0,0,22.983,1.008,1.008,0,0,0,1,24H11.261A5.477,5.477,0,0,1,10,20.5ZM9,12A6,6,0,1,0,3,6,6.006,6.006,0,0,0,9,12Zm9,9a1,1,0,0,1-1-1H12v.5A3.5,3.5,0,0,0,15.5,24h5A3.5,3.5,0,0,0,24,20.5V20H19A1,1,0,0,1,18,21Z",
    fill: "#004fb1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternship);
export default __webpack_public_path__ + "static/media/internship.63274c07331ea0b9a7a9f7da07a16ef2.svg";
export { ForwardRef as ReactComponent };